import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/testimonials';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/feature/Reveal';

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Voices"
        title="围观群众怎么说"
        description="来自常逛群众的一些真实反馈，也是我们把内容做下去的理由。"
        align="center"
      />

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {testimonials.map((item, index) => (
          <Reveal key={item.id} delay={(index % 2) * 100}>
            <figure className="h-full p-5 md:p-6 rounded-lg border border-background-200/80 bg-background-100/60">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-800">
                <i className="ri-double-quotes-l"></i>
              </span>
              <blockquote className="mt-4 text-sm md:text-base leading-relaxed text-foreground-800">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-bold">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.tag}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/about"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap"
        >
          了解 511群众的内容原则
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}